// Real-world uploads (especially from mobile) often come through with a
// generic MIME type like application/octet-stream rather than video/mp4, so
// file.type alone misses them - fall back to the extension in that case.
const VIDEO_EXTENSION_PATTERN = /\.(mp4|mov|avi|wmv|flv|webm|mkv|m4v|3gp|mpeg|mpg)$/i

export const isVideoFile = (file: File): boolean =>
  file.type.startsWith("video/") || VIDEO_EXTENSION_PATTERN.test(file.name)
